import { Popover as o, PopoverTrigger as r } from "@radix-ui/react-popover";
import { Popover as g, PopoverTrigger as i } from "@radix-ui/react-popover";
import { PopoverContent as e } from "./content/content.js";
const n = Object.assign(o, {
  Trigger: r,
  Content: e
});
export {
  n as Popover,
  e as PopoverContent,
  g as PopoverRoot,
  i as PopoverTrigger
};
